import { useStrings } from "features/i18n/useStrings";
import { useContext } from "react";

import { LevelContext } from "./Contexts";
import "./LevelIndicator.less";
import strings from "./LevelIndicator.strings";

export function LevelIndicator({
    variant = "default",
    inEditMode = false,
}: {
    variant?: "circle" | "default";
    inEditMode?: boolean;
}) {
    const { level, subLevel } = useContext(LevelContext);
    const t = useStrings(strings);
    return (
        <div
            className={`LevelIndicator${
                variant === "circle" ? " circled" : ""
            }${inEditMode ? " in-edit-mode" : ""}`}
        >
            {subLevel === 0 ? level : t.subLevel({ level, subLevel })}
        </div>
    );
}
